import React, { useState, useEffect, useContext } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ModalBox from "../../../../common/component/Modal/Index";
import { StoreContext } from "../../../../store";
import { FormControlLabel } from "@mui/material";
import { CheckBox } from "@material-ui/icons";
import "../../index.css";

function SelectColumn({
  columnName,
  onCheckboxChange,
  updateColumnName,
  orderActiveCol,
}) {
  const context = useContext(StoreContext);
  const [activeCol, setActiveCol] = useState({ ...orderActiveCol });
  const onUpdateActive = (ele, key) => {
    const arr = { ...activeCol };

    if (key === "OrderContainerRates") {
      arr.TotalCost = !arr[key];
      arr.ContainerCount = !arr[key];
    }

    arr[key] = !arr[key];

    setActiveCol({ ...arr });
  };

  useEffect(() => {
    setActiveCol({ ...orderActiveCol });
  }, [orderActiveCol]);

  return (
    <ModalBox title="Select Columns" class={"_orderColumnSelect"}>
      <div className="_solidButton">
        <button
          onClick={() => {
            updateColumnName(activeCol);
          }}
        >
          Apply
        </button>
      </div>
      <div className="_modalBody container-fluid">
        <div className="row selectColumnRow">
          {columnName.map((item, index) => {
            return (
              <div className="col-6 check_Container" key={index}>
                <input
                  disabled={item.Disabled}
                  onChange={(ele) => {
                    onUpdateActive(ele, item.key);
                  }}
                  checked={activeCol[item.key]}
                  type="checkbox"
                  id={"vehicle" + index}
                />
                <span>{item.Level}</span>
              </div>
            );
          })}
        </div>
      </div>
    </ModalBox>
  );
}

export default SelectColumn;
